"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilStudies = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
const CardRequirements_1 = require("../CardRequirements");
class SoilStudies extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SOIL_STUDIES,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.PLANT],
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.temperature(-4).max()),
            metadata: {
                cardNumber: 'P81',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plants(1).slash().venus(1).played.plus().plants(1).played.plus().colonies(1);
                }),
                description: 'Requires that temperature is -4 C or colder. Gain 1 plant for each Venus tag, plant tag (including this), and colony you have.',
            },
        });
    }
    play(player) {
        const count = player.getTagCount(Tags_1.Tags.VENUS) + player.getTagCount(Tags_1.Tags.PLANT) + 1 + player.getColoniesCount();
        player.addResource(Resources_1.Resources.PLANTS, count);
        return undefined;
    }
}
exports.SoilStudies = SoilStudies;
//# sourceMappingURL=SoilStudies.js.map